import { useTranslation } from "react-i18next";

import Button from "@/components/common/Button.tsx";
import { ChatMessage, ChatMessageType } from "@/components/common/ChatMessage.tsx";

// An unanswered question stays on screen with a one-tap resend. It lives outside
// chatHistory, so the next request never carries a turn without an answer.
export function ChatAskFailed({ question, onRetry }: { question: string; onRetry: () => void }) {
  const { t } = useTranslation();

  return (
    <>
      <ChatMessage message={question} type={ChatMessageType.QUESTION} />
      <div className="flex items-center justify-end gap-3 p-2">
        <span className="text-sm text-red-700">{t("chat.askFailed")}</span>
        <Button type="button" variant="outline" className="flex-shrink-0" onClick={onRetry}>
          {t("chat.tryAgain")}
        </Button>
      </div>
    </>
  );
}
